module.exports = __webpack_public_path__ + "img/reset-step-two.132577f5.png";